import close from "../../assets/images/close.svg";
export default function MobileMenu({
  isOpen,
  toggleSidebar
}) {
  return (
    <div
      className={`lg:hidden fixed top-0 -translate-x-full left-0 w-full h-full z-[1000] bg-[#0000004D] pointer-events-none  transition-all duration-500 ${isOpen && " pointer-events-auto translate-x-0"
        }`}
    >
      <div className="bg-[#004D99] flex flex-col">
        <div className="flex w-full justify-end pr-5 pt-5">
          <img src={close} alt="close" width={30} height={30} className="cursor-pointer"
            onClick={toggleSidebar}
          />
        </div>
        <div className="flex flex-col mt-[10px] pl-[30px] pb-[70px]">
          <h3 className="text-[#fff] font-bold text-[16px] cursor-pointer pb-5 ransition-colors duration-300 hover:text-[#EB4A00] w-max"
            onClick={() => {
              toggleSidebar()
              setTimeout(() => {
                const element = document.getElementById("what-we-do");
                const offset = 50;

                if (element) {
                  const elementPosition = element.getBoundingClientRect().top + window.scrollY;
                  window.scrollTo({ top: elementPosition - offset, behavior: "smooth" });
                }
              }, 300);
            }}

          >
            What we do
          </h3>
          <h3 className="text-[#fff] font-bold text-[16px] cursor-pointer pb-5 transition-colors duration-300 hover:text-[#EB4A00] w-max"
            onClick={() => {
              toggleSidebar()
              setTimeout(() => {
                const element = document.getElementById("our-works");
                const offset = 80;

                if (element) {
                  const elementPosition = element.getBoundingClientRect().top + window.scrollY;
                  window.scrollTo({ top: elementPosition - offset, behavior: "smooth" });
                }
              }, 300);
            }}
          >

            Our Works
          </h3>
          <h3 className="text-[#fff] font-bold text-[16px] cursor-pointer pb-5 transition-colors duration-300 hover:text-[#EB4A00] w-max"
            onClick={() => {
              toggleSidebar()
              setTimeout(() => {
                document.getElementById('contacts').scrollIntoView({ behavior: "smooth", duration: 500 })
              }, 300);
            }}
          >
            Contacts
          </h3>
        </div>
      </div>
    </div>
  );
}
